import * as React from "react";
import { Text, Tabs, DialogContent, Flex } from "@theorgchartdev/storybook";
import { DetailSectionNames } from "../../../../../providers/NavigationProvider";
import cx from "classnames";
import { ApplicationDetails } from "./ApplicationDetails/ApplicationDetails";
import { AccountDetails } from "./AccountDetails/AccountDetails";
import { UserDetails } from "./UserDetails/UserDetails";
import { ChartDetails } from "./ChartDetails/ChartDetails";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";
import { CapitalizeFirstWord } from "@/Utils/DataLib";
import { getFeatureAccess } from "@/Utils/Misc";
import { enumFeaturesList } from "@coreapp/constants";
import { GetDoc } from "@/Utils/StateLib";

const Details = ({ currentTab, setCurrentTab }) => {
  const handleTabChange = currentTabIndex => {
    setCurrentTab(currentTabIndex);
  };

  const GetTabContent = section => {
    let key = DetailSectionNames[section];
    let sectionTab = {};
    sectionTab.header = CapitalizeFirstWord(appstr(key));
    let content = null;

    switch (key) {
      case DetailSectionNames.ApplicationDetails:
        content = <ApplicationDetails />;
        break;
      case DetailSectionNames.AccountDetails:
        content = <AccountDetails />;
        break;
      case DetailSectionNames.UserDetails:
        content = <UserDetails />;
        break;
      case DetailSectionNames.ChartDetails:
        const isPlan = GetDoc()?.IsPlanChart() ?? false;
        if (isPlan) {
          sectionTab.header = appstr("Plan");
        }
        content = <ChartDetails />;
        break;
      default:
        content = (
          <Text size={"medium"} modifier={"medium"} colorModifier={"grey"}>
            {"Area under construction"}
          </Text>
        );
        break;
    }
    sectionTab.content = (
      <div className={cx("ocn-settings-content", "ocn-list-scrollbar")}>{content}</div>
    );
    return sectionTab;
  };

  const GetTabs = () => {
    let tabList = [];
    for (let section in DetailSectionNames) {
      if (
        section == "UserDetails" &&
        !Globals._uiConfig.fShowCurrentUser &&
        !getFeatureAccess(enumFeaturesList.userDetails)
      ) {
        continue;
      } else tabList.push(GetTabContent(section));
    }
    return tabList;
  };

  return (
    <React.Fragment>
      <Flex direction={"column"} height={"100%"}>
        <DialogContent customContentClass={"ocn-settings-container"}>
          <div className={"ocn-settings-content-container"}>
            <Tabs
              tabIndex={parseInt(currentTab)}
              customClass={"ocn-settings-tabs"}
              customContentClass={"ocn-settings-tabs-content"}
              tabs={GetTabs()}
              onTabChange={handleTabChange}
            />
          </div>
        </DialogContent>
        <Text>
          © {new Date().getFullYear()} {appstr("OrgChart LLC. All rights reserved")}
        </Text>
      </Flex>
    </React.Fragment>
  );
};

export default Details;
